import { NgModule } from "@angular/core";
import { Routes, RouterModule } from '@angular/router';
import { LicitabenAssinaturaComponent } from "./licitaben-assinatura.component";

const routes: Routes = [ 
  { 
    path: 'licitabenassinatura/:id', component: LicitabenAssinaturaComponent 
  } 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicitabenAssinaturaRoutingModule {}
